import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../header";
import Footer from "../footer";
import Loader from "../guestPortal/loader";

function ConfirmationBookingPage() {
  const [state, setState] = useState({
    orderId: "",
    communityDetails: {},
    checkin: null,
    checkout: null,
    loader: true,
  });
  const location = useLocation();
  const { orderId, message } = location.state || {};
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  console.log(orderId, message, "orderId, message");

  // const orderId = query.get("orderId");
  useEffect(() => {
    try {
      const savedState = localStorage.getItem("reserveState");
      let normalObject = JSON.parse(savedState);
      if (normalObject) {
        setState((prev) => ({
          ...prev,
          communityDetails: normalObject.communities,
          checkin: normalObject.checkin,
          checkout: normalObject.checkout,
          loader: false,
        }));
      }
    } catch (error) {
      console.log(error, "error");
    }
  }, []);

  return (
    <div className="SAweb_updateUi">
      <Header />

      {state.loader ? (
        <Loader />
      ) : (
        <div className="bookingSuccessView">
          <div className="container">
            <div className={`done ${message ? "paymentPending" : ""}`}>
              <i className="bi bi-check-circle"></i>

              <p>
                {!message ? "Your Order has been confirmed !" : message}
                <span>Thank you for being with us</span>
              </p>
            </div>
            <div className="orderDetails">
              <h2 className="h2">Order Details</h2>

              <div className="box">
                <div className="address">
                  <img src={state.communityDetails.banner_image} alt="" />
                </div>
                <div className="details">
                  <p>
                    {state.communityDetails.community_name}
                    <span>
                      {state.communityDetails.address},
                      {" " + state.communityDetails?.city_name?.toLowerCase()}
                    </span>
                  </p>

                  <h4>
                    {" "}
                    Order Id : <span>#{orderId}</span>
                  </h4>
                  <ul>
                    <li>
                      Move-in <span>{state.checkin}</span>
                    </li>
                    <li>
                      Move-out <span>{state.checkout}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <hr />

              <h2>Questions?</h2>
              <h3>
                <a href="mailto:someone@example.com"> Send us an email </a> or
                give us a call 800.367.9501
              </h3>
              <h2>Download the app today</h2>
              <h3>
                <a
                  href="https://play.google.com/store/apps/details?id=com.suiteamerica.guestapp"
                  target="_blank"
                  className="mrg-right-15"
                >
                  <img
                    src="https://chapp-bucket.s3.us-west-1.amazonaws.com/googlePlayStoreIcon.png"
                    alt=""
                    width={130}
                  />
                </a>
                <a
                  href="https://apps.apple.com/us/app/guestportal/id1492423942"
                  target="_blank"
                >
                  <img
                    src="https://chapp-bucket.s3.us-west-1.amazonaws.com/appStoreIcon.png"
                    alt=""
                    width={130}
                  />
                </a>
              </h3>
              <h3>
                Click{" "}
                <a
                  href="https://www.suiteamerica.com/guest-login"
                  target="_blank"
                  className=""
                >
                  here
                </a>{" "}
                to log in to the guest portal and view your reservations.
              </h3>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default ConfirmationBookingPage;
